import { ROLES } from "./general.constant";

export const NOTIFICATION_LABELS: Record<string, string> = {
  document_request: "Document request",
  document_reminder: "Document reminder",
  document_uploaded: "Document uploaded",
  document_updated: "Document updated",
  document_accepted: "Document accepted",
  document_rejected: "Document needs update",
  deal_status_update: "Deal status",
  banker_assigned: "Banker assigned",
  deal_assigned: "Deal assigned",
  term_sheet_received: "Term sheet",
  closing_reminder: "Closing reminder",
  customer_details_shared: "Customer details",
  lead_created: "Lead created",
  lead_invited: "Lead invited",
  lead_registered: "Lead registered",
  customer_registered: "Customer registered",
  deal_created: "Deal created",
  banker_invited: "Banker invited",
  banker_registered: "Banker registered",
  business_registered: "Business registered",
  demo_request: "Demo request",
  contact_submission: "Contact submission",
  waitlist_signup: "Waitlist signup",
  bid_response: "Bid response",
  task_assigned: "Task assigned",
};

export const NOTIFICATION_ROLE_TYPE_MAP: Record<string, string[]> = {
  [ROLES.CUSTOMER]: [
    "document_request",
    "document_reminder",
    "document_accepted",
    "document_rejected",
    "deal_status_update",
    "banker_assigned",
    "term_sheet_received",
    "closing_reminder",
  ],
  [ROLES.BANKER]: [
    "deal_assigned",
    "document_uploaded",
    "document_updated",
    "customer_details_shared",
    "bid_response",
  ],
  [ROLES.BUSINESS]: [
    "lead_created",
    "lead_invited",
    "lead_registered",
    "customer_registered",
    "deal_created",
    "deal_status_update",
    "banker_invited",
    "banker_registered",
    "bid_response",
    "task_assigned",
  ],
  [ROLES.CO_OWNER]: [
    "lead_created",
    "lead_invited",
    "lead_registered",
    "customer_registered",
    "deal_created",
    "deal_status_update",
    "banker_invited",
    "banker_registered",
    "bid_response",
    "task_assigned",
  ],
  [ROLES.EMPLOYEE]: [
    "lead_created",
    "lead_invited",
    "lead_registered",
    "customer_registered",
    "deal_created",
    "deal_status_update",
    "banker_invited",
    "banker_registered",
    "bid_response",
    "task_assigned",
  ],
  [ROLES.ADMIN]: [
    "business_registered",
    "demo_request",
    "contact_submission",
    "waitlist_signup",
  ],
};

export const NOTIFICATION_ROW_OPTIONS = [10, 25, 50];

export const NOTIFICATION_STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "unread", label: "Unread" },
  { value: "read", label: "Read" },
];

export const NOTIFICATION_COPY = {
  title: "Notifications",
  subtitle: "Track deal, document, lead, and account updates.",
  totalSuffix: "total",
  searchPlaceholder: "Search notifications, deals, or types",
  statusLabel: "Status",
  typeLabel: "Type",
  allTypesLabel: "All types",
  rowsLabel: "Rows",
  clearLabel: "Clear",
  loading: "Loading notifications...",
  emptyTitle: "No notifications found",
  emptyDescription: "New activity will appear here as your deals and documents move forward.",
  newLabel: "New",
  markAsRead: "Mark as read",
  dealLabel: "Deal",
  bankerLabel: "Banker",
  showingLabel: "Showing",
  toLabel: "to",
  ofLabel: "of",
  loadError: "Unable to load notifications.",
  markReadError: "Unable to mark notification as read.",
};

export const NOTIFICATION_COLORS = {
  pageBackground: "#F6F8FB",
  brand: "#004D95",
  brandLight: "#E9F2FB",
  unreadBackground: "#F0F7FF",
  unreadIconBackground: "#D9EBFF",
  readIconBackground: "#EEF1F5",
  white: "#fff",
  transparent: "transparent",
};
